import { Transaction } from '@web/walter-lib/stream/types'
import { NotificationProps } from '@web/walter-lib/notifications'
import { processSwap } from './processSwap'
import { processDeposit } from './processDeposit'
import { processWithdraw } from './processWithdraw'
import { processTransfer } from './processTransfer'

const notification = {
    intent: 'notification' as const,
    createdAt: Date.now(),
}

// eslint-disable-next-line complexity
export const processData = (data: Transaction): NotificationProps | undefined => {
    if (data.type === 'SWAP' || data.type === 'OTC') {
        const swapData = processSwap(data)

        if (!swapData) {
            return
        }

        return { ...notification, ...swapData }
    } else if (data.type === 'DEPOSIT') {
        const depositData = processDeposit(data)

        if (!depositData) {
            return
        }

        return { ...notification, ...depositData }
    } else if (data.type === 'WITHDRAW') {
        const withdrawData = processWithdraw(data)

        if (!withdrawData) {
            return
        }

        return { ...notification, ...withdrawData }
    } else if (data.type === 'TRANSFER') {
        const withdrawData = processTransfer(data)

        if (!withdrawData) {
            return
        }

        return { ...notification, ...withdrawData }
    }

    return
}
